// $('.mixology-main-slider').slick({
//     slidesToShow: 1,
//     slidesToScroll: 1,
//     arrows: false,
//     fade: true,
//     adaptiveHeight:true//,
//     // asNavFor: '.mixology-small-slider'
// }).on('afterChange', function(){
//     $('#bottleName').val($('.mrk-mixology-item.slick-current').attr('name'));
// });;
// $('.mixology-small-slider').slick({
//     slidesToShow: 6,
//     slidesToScroll: 1,
//     adaptiveHeight:true,
//     // asNavFor: '.mixology-main-slider',
//     dots: false,
//     arrows: true,
//     prevArrow: '<button type="button" class="mrk-slick-btn mrk-slick-prev">Previous</button>',
//     nextArrow: '<button type="button" class="mrk-slick-btn mrk-slick-next"></button>',
//     focusOnSelect: true,
//     responsive: [{
//         breakpoint: 991,
//         settings: {
//             slidesToShow: 5,
//             slidesToScroll: 1
//         }
//     }]
// });
let maxTotal = 100;
// Function to update the max value of the other sliders
function allTotal(){
    var total = 0;
    // Calculate the sum of the values of all range sliders
    $('.range-slider__range').each(function() {
        total += parseInt($(this).val());
    });
    return total
}
function updateMaxValues(changedSlider) {
    var total = allTotal();
    var previousValue = changedSlider.data('previous') || 0; // Store the previous value

    // If the total exceeds 100 and the recent change was an increase, revert it
    if (total > 100 && parseInt(changedSlider.val()) > previousValue) {
        changedSlider.val(previousValue);
    }    // Update the 'previous' data attribute for each slider
    $('.range-slider__range').each(function() {
        $(this).data('previous', $(this).val());
        var value = $(this).val();
        var parent = $(this).closest('.mrk-range-mixology');
        parent.find('.mrk-percent').text(value);
        if(value == 0 && allTotal() == 100){
            $(this).addClass('mrk-range-disabled');
        }else{
            $(this).removeClass('mrk-range-disabled');
        }
    });
    if(total > 100)
    total = 100;
    $('.mrk-final-percent').text(`${allTotal()}%`);
    if(total == 0)
    total = -1;
    $('.mrk-water-wave').css('transform',`translate(0px, ${100 - total}%)`)
    UpdateNameMeta();
    enableFinalAddToCart();
}
function enableDisableRanges(){
    $('.mrk-mixology-selection-item').each(function(){
        const Brand = $(this).find('.selectbottlebrand .selected-value[value]').text();
        const fragrance = $(this).find('.mrk-final-product-list .selected-value[value]').text();
        if((Brand == '' || Brand == undefined) || (fragrance == '' || fragrance == undefined)){
            $(this).find('.range-slider__range').addClass('mrk-range-disabled');
        }else{
            $(this).find('.range-slider__range').removeClass('mrk-range-disabled');
        }
    })
}

// On change event for the range sliders
$('.range-slider__range').on('input', function() {
    var value = $(this).val();
    var parent = $(this).closest('.mrk-range-mixology');
    parent.find('.mrk-percent').text(value);

    // Update the max values of the other sliders
    updateMaxValues($(this));
    UpdateNameMeta();
});
function initSearch() {
    // Handle input event with delegation
    $('.mrk-search-bar input').unbind('input');
    $('.mrk-search-bar input').on('input', function() {
        const searchValue = $(this).val().toLowerCase();
        const linkList = $(this).parents('.mrk-custom-dropdown').find('.option-list li');
        console.log(searchValue.length, $(this));

        if (searchValue.length === 0) {
            linkList.show();
            return;
        }
        linkList.each(function() {
            const linkText = $(this).text().toLowerCase();
            linkText.includes(searchValue) ? $(this).show() : $(this).hide();
        });
    });
}
function renderBrandProducts(li){
    var url = $(li).attr('value');
    var selector = $(li).parents('.mrk-brand-fragrance-mixology').find('.model-select');
    getData(url,selector);
}
function UpdateVariantId(e){
    var _id = $(e).attr('value');
    $(e).parents('.final-add-to-cart').find('[name="id"]').val(_id);
}
function updateMeta(li){
    var container = $(li).parents('.mrk-mixology-selection-item');
    const Brand = $(container).find('.selectbottlebrand .selected-value[value]').text();
    const fragrance = $(container).find('.mrk-final-product-list .selected-value[value]').text();
    var fragranceName = $(container).find('.mrk-fragrance').attr('data-name');
    var BrandName = $(container).find('.mrk-brand').attr('data-name');
    UpdateNameMeta();
}
function UpdateNameMeta(){
    var index = 1;
    $('.mrk-mixology-selection-item').each(function(){
        var container = $(this);
        const Brand = $(container).find('.selectbottlebrand .selected-value[value]').text();
        const fragrance = $(container).find('.mrk-final-product-list .selected-value[value]').text();
        const percent = $(container).find('input[type="range"]').val();
        if(percent != 0){
            $(container).find('.mrk-info-properties').html(`
                <input type="hidden" class="mrk-brand" name="properties[${Brand} - ${index}]" value="${fragrance} ${percent}%">
            `);
            index++;
        }else{
            $(container).find('.mrk-info-properties').html('');
        }
    })
}
function initSelect(){
    $('.mrk-selected-option').unbind('click');
    $('.mrk-custom-dropdown li').unbind('click');
    $(".mrk-selected-option").click(function (e) {
        e.preventDefault();
        $(this).parents('.mrk-custom-dropdown').find('.mrk-search-bar-input').focus();
        var currentDropdown = $(this).parents(".mrk-custom-dropdown").find(".dropdown-wrapper");
          // Close other dropdowns, but leave the current one as is
          $(".dropdown-wrapper").not(currentDropdown).slideUp("fast");
          // Toggle the current dropdown
          currentDropdown.slideToggle("fast");
      });
    $('.mrk-custom-dropdown li').click(function (e) {
        $(this).parents('.dropdown-wrapper').slideUp('fast');
        var value = $(this).attr('value');
        var text = $(this).text();
        $(this).parents('.mrk-custom-dropdown').find('.selected-value').text(text).attr('value', value);
        if($(this).parents('.mrk-custom-dropdown').hasClass('selectbottlebrand')){
            $(this).parents('.mrk-mixology-selection-item').find('.range-slider__range').val('0').trigger('input');
            renderBrandProducts($(this));
        }
        UpdateNameMeta();
        enableFinalAddToCart();
    });
    $(document).click(function(e) {
        if (!$(e.target).closest('.mrk-custom-dropdown').length) {
            $('.dropdown-wrapper').slideUp('fast');
        }
    });
}
function enableFinalAddToCart() {
    enableDisableRanges();
    $('.mrk-mixology-selection-item').each(function(){
        if($(this).find('input[type="range"]').val() == 0 && allTotal() != 0)
        return;
        const BrandLength = $(this).find('.selectbottlebrand .selected-value[value]').length;
        const checkedLength = $(this).find('.mrk-final-product-list .selected-value[value]').length;
        const quantity = allTotal() == 100;
        const isDisabled = checkedLength && BrandLength && quantity;
        $('.mrk-final-add-to-cart-bar').find('[is="custom-button"]').prop('disabled', !isDisabled).toggleClass('disabled', !isDisabled);
        
    })
}
function getData(url,selector,callback){
    var callback = callback || function() { };
    $.ajax({
        type: "GET",
        url,
        dataType: "html",
        cache: true,
        beforeSend: function(){
            $(selector).html(`<div class="mrk-loader"><div class="lds-dual-ring"></div></div>`).addClass('mrk-loading');
        },
        success: function (response) {
            selector.html(response).removeClass('mrk-loading');
            callback();
            bindEvents();
        }
    });
}
function bindEvents(){
    initSearch();
    initSelect();
}
initSelect();
initSearch();
enableFinalAddToCart();